import { compareSpecifiers } from "./compare-specifiers.js";
const findBoostedOdds = (boostedOdds, eventId, marketId, outcomeId, specifiers) => (boostedOdds || []).find(
  (odd) => Number(odd.eventId) === Number(eventId) && Number(odd.marketId) === Number(marketId) && Number(odd.outcomeId) === Number(outcomeId) && compareSpecifiers(odd.specifiers, specifiers)
);
export {
  findBoostedOdds
};
